import DOLLAR from './assets/dollar.svg';
import ERROR_DOLLAR from './assets/error_dollar.svg';

export const TipComponent = {
    template: `
        <ng-form name="$ctrl.tipForm">
        <p c-type="body-sm-primary bold">Add Tip</p>
        <div class="radio-bar separate">
            <input type="radio" id="{{$index}}-tip"
                ng-repeat-start="tip in $ctrl.cart.preComputedTips"
                ng-model="$ctrl.paymentService.data.selectedPayment.tip"
                ng-value="$ctrl.getVal(tip.value)">
            <label for="{{$index}}-tip" ng-repeat-end ng-bind-template="{{tip.percent * 100 | number:0}}%"
                ga-track-event="$ctrl.getStandardTipEvent(tip)"></label>
        </div>
        <div class="flex-row">
            <div class="column expand column-md-3">
                <fieldset>
                    <oo-input-container class="icon-left-sm">
                        <oo-input-icon
                            icon-valid-src="'${DOLLAR}'"
                            icon-invalid-src="'${ERROR_DOLLAR}'"
                        ></oo-input-icon>
                        <input
                            formatted-tip
                            id="field-card-tip"
                            min="0"
                            name="card-tip"
                            ng-model="$ctrl.paymentService.data.selectedPayment.tip"
                            ng-required="false"
                            step="0.01"
                            type="number"
                        />
                        <label>Add Tip</label>
                        <div ng-messages="$ctrl.tipForm['card-tip'].$error">
                            <div ng-messages-include="generic-messages"></div>
                            <div ng-message="min, number, step">Enter a valid tip amount</div>
                        </div>
                    </oo-input-container>
                </fieldset>
            </div>
        </div>
        </ng-form>
    `,
    controller: class {
        constructor(cartService, googleAnalyticsTrackingService, paymentService) {
            'ngInject';
            Object.assign(this, {
                cartService,
                googleAnalyticsTrackingService,
                paymentService
            });
            this.math = Math;
        }

        $onInit() {
            this.cartService.getCart()
                .then(cart => this.cart = cart);
        }

        getVal(tip) {
            return this._getVal(tip);
        }

        _getVal(tip) {
            return parseFloat(this.math.round(tip * 100) / 100);
        }

        getStandardTipEvent(tip) {
            return this.googleAnalyticsTrackingService.getStandardTipEvent(tip);
        }
    }
};
